// extracted by mini-css-extract-plugin
export default {"modalContent":"ImageModal_modalContent__dQkq-","modalBody":"ImageModal_modalBody__R6zcF"};